import type { NskResponse } from '~/models/Api';
import { generatePath } from '~/utils/generatePath';
import { putRequest } from '../../api_handler';

export const update = async (dealId: number): Promise<NskResponse<void>> =>
  putRequest(
    generatePath('admin/deals/:deal_id/revert_status', { deal_id: dealId })
  );
